<div class="flex flex-col flex-auto">
  <mat-drawer-container>
    <mat-drawer [mode]="drawerMode" [opened]="false" [position]="'end'" [disableClose]="false" #matDrawer>
      <router-outlet></router-outlet>
    </mat-drawer>
    <mat-drawer-content class="flex flex-col inset-0 absolute leases-content">
      <header class="leases-content__header">
        <mat-button-toggle-group [value]="savedView">
          <mat-button-toggle
            (click)="onSavedViewSelectionChange(sv)"
            [value]="sv"
            *ngFor="let sv of savedViews; trackBy: trackByFn"
          >
            <span>{{ sv.name }}</span>
            <button
              class="ml-2 lt-md:hidden"
              mat-icon-button
              (click)="openFieldDefsPanel()"
              #customFieldPanelOrigin
              #fieldDefsPanelOrigin
              [disabled]="savedView?.id !== sv.id"
            >
              <mat-icon [svgIcon]="'visibility'"></mat-icon>
            </button>
          </mat-button-toggle>
        </mat-button-toggle-group>
        <section class="leases-content__header--actions">
          @if (this.savedView.related_to_type === 'PropertyTenant') {
            @if (canImportLeaseAbstract()) {
              <input hidden type="file" (change)="onSelectLeaseAbstractFile($event)" #fileInput />
              <ts-button
                variant="secondary"
                icon="ts_file-import"
                class="mr-2"
                data-dd-action-name="tasks-header-export"
                [appAuthorize]="NewPermission.LEASES_CREATE"
                data-testid="export-tasklist-button"
                (click)="fileInput.click()"
                >Import</ts-button
              >
            }
            <button
              mat-flat-button
              [color]="'primary'"
              (click)="addLease()"
              [matTooltip]="'Add Lease'"
              data-cy="property-unit-add-lease"
              [appAuthorize]="NewPermission.LEASES_CREATE"
              denyAction="disable"
            >
              <mat-icon [svgIcon]="'add'"></mat-icon>
              Add Lease
            </button>
          }
          @if (this.savedView.related_to_type === 'FacilityReport') {
            <button
              mat-flat-button
              [color]="'primary'"
              (click)="addFacilityReport()"
              [matTooltip]="'Add Facility Report'"
            >
              <mat-icon [svgIcon]="'add'"></mat-icon>
              Add Facility Report
            </button>
          }
          <button
            [appAuthorize]="NewPermission.LEASES_DELETE"
            class="more-menu ml-4"
            mat-icon-button
            [matMenuTriggerFor]="moreMenu"
            data-cy="property-unit-menu"
          >
            <mat-icon [svgIcon]="'more_vert'"></mat-icon>
          </button>
          <mat-menu #moreMenu="matMenu">
            <button mat-menu-item (click)="deletePropertyUnit()" data-cy="delete-property-unit-button">
              <mat-icon [svgIcon]="'delete'"></mat-icon>
              <span>Delete</span>
            </button>
          </mat-menu>
        </section>
      </header>

      <main class="leases-content__main">
        <section class="table-wrapper">
          @if (this.savedView.related_to_type === 'PropertyTenant') {
            <ts-table
              (gridReady)="onGridReady($event)"
              [columnDefs]="columnDefs"
              [rowData]="propertyTenantsDataSource.data"
              [autoHeight]="false"
              [data]="data"
              [gridOptions]="gridOptions"
              [actions]="tsActions"
              [clientSorting]="true"
              (cellEditingStopped)="onCellEditingStopped($event)"
              (onColumnMove)="onColumnMoved($event)"
              (sortChanged)="onSortChanged($event)"
              [hasOpenDetailsColumn]="true"
              (openDetails)="onOpenDetails($event)"
            >
            </ts-table>
          }

          @if (this.savedView.related_to_type === 'FacilityReport') {
            <ts-table
              (gridReady)="onGridReady($event)"
              [columnDefs]="columnDefs"
              [rowData]="facilityReportsDataSource.data"
              [autoHeight]="false"
              [data]="data"
              [gridOptions]="gridOptions"
              [clientSorting]="true"
              (cellEditingStopped)="onCellEditingStopped($event)"
              (onColumnMove)="onColumnMoved($event)"
              (sortChanged)="onSortChanged($event)"
              [hasOpenDetailsColumn]="true"
              (openDetails)="onOpenDetails($event)"
            >
            </ts-table>
          }
        </section>
      </main>
    </mat-drawer-content>
  </mat-drawer-container>
</div>

<ng-template #fieldDefsPanel>
  <div class="contacts-details-tags-panel">
    <div class="tags-panel-header">
      <div class="new-tag">
        <mat-icon [svgIcon]="'search'"></mat-icon>
        <input
          type="text"
          placeholder="Enter field name"
          (input)="filterFields($event)"
          (keydown)="filterFieldsInputKeyDown($event)"
          [maxLength]="50"
          #newTagInput
        />
      </div>
    </div>

    <div class="available-tags">
      <ng-container>
        <mat-checkbox
          *ngFor="let fieldDef of filteredFieldDefs; trackBy: trackByFn"
          [color]="'primary'"
          [checked]="displayColumns.includes(fieldDef.name)"
          (change)="toggleDisplayColumn(fieldDef.name, $event)"
        >
          {{ fieldDef.label }}
        </mat-checkbox>
      </ng-container>
    </div>
  </div>
</ng-template>
